import { css } from '@emotion/core';

export const close = css`
    position: absolute;
    top: 22px;
    right: 13px;

    button {
      padding: 0;
      border: 0;
      background: transparent;
    }
`;

export const overlay = css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.65);
    overflow-y: auto;
    z-index: 9999;
`;

export const bodyContent = css`
    overflow-y: auto;
`;

export const modalContent = css`
      background: #FFF;
      padding: 80px 20px;
      position: relative;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      max-height: 100%;
      

      @media (min-width: 768px) {
        padding: 80px 35px;
      }

      @media (min-width: 980px) {
        padding: 80px 69px;
        max-height: 1057px;
        max-width: 768px;
        top: 80px;
        margin: auto;
        box-shadow: 2px 2px 15px #000;
      }
`;